let Root;
if (process.env.isDev) {
  Root = require('./Root.dev').default;
} else {
  Root = require('./Root.prod').default;
}

export default Root;
